export function numberToWholeNumberLocaleString(someNumber: number, locale: Intl.LocalesArgument) {
  return someNumber.toLocaleString(locale, {maximumFractionDigits: 0});
}
